export const POPUP = {
    MONEY: 'money',
    SHIPPING: 'shipping',
} as const;
